export const yesNoOption = ['Yes', 'No'];
export const vehicalCheckListOption = ['Faulty', 'Repaired', ''];
export const machineList = [
  'Kotmatsu Forwarder',
  'Chipper Kompteck 5010',
  'Chipper Volvo & CBI FH13 / CBI 484',
  'AJ7689 Dennision LowLoader',
  '1397 JDeere 1070D',
  '1249 JDeere 1270D',
  '2030 JDeere 810D',
  '694 JDeere 1110',
  '2262 JDeere 1070E',
  '5422 JDeere 1010E',
  'A030276 Ponn51',
  'A010401 Ponsse Scorpion King',
  'A040129 Ponsse Scorpion',
  'A030166 Ponsse Buffalo',
  'A080676 Ponsse Wisent',
  '109 Timberjack 870',
  '1532387 Teleportor 536/60',
  'Posch firewood processor 3200',
  'Posch Auto Spliter',
  'None',
  'Trial Machine',
];
export const checklistCompletedOption = ['Completed', 'Not Completed'];
export const speciesOptions = [
  'Sitka Spruce',
  'Norway Spruce',
  'Douglas Fir',
  'Larch',
  'Hardwood',
  'Softwood',
  'Lodgepole Pine',
];
export const detailedM3Options = [
  '7.3 Sawlog',
  '6.7 Sawlog',
  '6.1 Sawlog',
  '5.5 Sawlog',
  '4.9 Sawlog Oversize',
  '4.9 Sawlog G1',
  '4.9 Sawlog G2',
  '4.3 Sawlog',
  '3.7 Sawlog - 16',
  '3.8 Stake',
  '3.4 Stake - 7',
  '3.2 Stake - 7',
  '3.7 Pallet - 14',
  '3.4 Pallet - 14',
  '3.1 Pallet - 14',
  '3.0 Pulp - 7',
  '3.0 Pulp - 1',
  '2 to 6 Pulp - 1',
  '3 Firewood',
  '3 Deadwood',
  '3 Brash only',
  '3 Hardwood Tops/Trees',
  '2.5 Pallet',
  '2.2 Pallet',
  '1.9 Stake',
  '1.7 Stake',
  '1.6 Stake',
  'Whole Tree (Units)',
  '0 Other',
];
